import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterStore } from '../../../services/api/footer/footer-store.service';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { FooterBlockComponent } from './footer-block/footer-block.component';
import { FormsModule } from '@angular/forms';
import { QuillViewComponent } from 'ngx-quill';
import { LoadingAnimationComponent } from '../../feedback/loading-animation/loading-animation.component';
import { ToFontSizePipe } from '../../../pipes/to-font-size/to-font-size.pipe';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { EEntityType, ERelationType, IFooter } from '@web/dtos';

@Component({
  selector: 'aw-footer',
  imports: [
    CommonModule,
    LanguagePipe,
    FooterBlockComponent,
    FormsModule,
    QuillViewComponent,
    LoadingAnimationComponent,
    ToFontSizePipe,
    FilterTextsPipe,
  ],
  templateUrl: './footer.component.html',
  styles: ``,
})
export class FooterComponent {
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly footerStore: FooterStore = inject(FooterStore);
  protected readonly RelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;

  protected isFooterBlockVisible(footer: IFooter, blockId: string): boolean {
    if ((footer.layout?.hiddenBlocks ?? []).includes(blockId)) {
      return false;
    }

    if (blockId === 'linkArea') {
      return true;
    }

    const customBlock = footer.blocks?.find(block => block.id === blockId);
    if (customBlock) {
      return customBlock.isActive;
    }

    return (
      footer[blockId as 'logoArea' | 'addressArea' | 'paymentArea']?.isActive ??
      false
    );
  }

  protected isHeadlineVisible(footer: IFooter, blockId: string): boolean {
    if (blockId === 'linkArea') {
      return true;
    }

    const customBlock = footer.blocks?.find(block => block.id === blockId);
    if (customBlock) {
      return customBlock.isActive;
    }

    return (
      footer[blockId as 'logoArea' | 'addressArea' | 'paymentArea']?.isActive ??
      false
    );
  }

  protected footerBlockOrder(footer: IFooter, blockId: string): number {
    const defaultOrder = ['logoArea', 'addressArea', 'paymentArea', 'linkArea'];
    const blockOrder = footer.layout?.blockOrder ?? defaultOrder;
    const order = blockOrder.indexOf(blockId);

    return order === -1 ? blockOrder.length : order;
  }

  protected hasRowBreak(footer: IFooter): boolean {
    return (footer.layout?.blockOrder ?? []).includes('ROW_BREAK');
  }

  protected backgroundImage(footer: IFooter): string | null {
    const imageId = footer.appearance?.backgroundImage?.id;

    return footer.appearance?.showBackgroundImage && imageId
      ? `url(${this.footerStore.backgroundImagePath(imageId)})`
      : null;
  }
}
